/**
 * CA相关数据字典
 */
import DictUtil from '@/utils/dict-utils'

// CA类型
export const CATypeDict = new DictUtil({
  MKEY: { label: '移动CA数字证书', value: 1 },
  UKEY: { label: '实体CA数字证书', value: 0 }
})

// CA购买类型
export const CAPaidTypeDict = new DictUtil({
  FIRST: { label: '新领', value: 1 },
  RENEWAL: { label: '续费', value: 2 },
  MAKE_UP: { label: '补办', value: 3 }
})

// 移动CA状态
export const MKeyStatusDict = new DictUtil({
  PENDING: { label: '待申领', value: 0, type: 'warning' },
  IN: { label: '已生效', value: 1, type: 'success' },
  OUT: { label: '已过期', value: 2, type: 'danger' }
})

// 实体CA状态
export const UKeyStatusDict = new DictUtil({
  PENDING: { label: '处理中', value: 0, type: 'primary' },
  IN: { label: '已生效', value: 1, type: 'success' },
  OUT: { label: '已过期', value: 2, type: 'danger' }
})

// CA支付状态
export const CAPayStatusDict = new DictUtil({
  PENDING: { label: '未支付', value: 0 },
  FINISH: { label: '已支付', value: 1 }
})

// CA领取状态
export const CAReceiveStatusDict = new DictUtil({
  UN_RECEIVE: { label: '未领取', value: 0 },
  RECEIVED: { label: '已领取', value: 1 }
})

// 实体CA申请审核状态
export const UKeyAuditStatusDict = new DictUtil({
  PENDING: { label: '待审核', value: 0, type: 'warning' },
  SUCCESS: { label: '审核通过', value: 1, type: 'success' },
  FAIL: { label: '驳回', value: 2, type: 'danger' }
})

// UKey配送方式
export const UKeySendTypeDict = new DictUtil({
  LOCAL: {
    label: '到现场领取',
    value: 1,
    tip: '南昌市推荐，领取人需要携带加盖公章的营业执照'
  },
  MAILING: { label: '邮寄', value: 2, tip: '顺丰到付' }
})

// CA办理类型
export const UKeyApplyTypeDict = new DictUtil({
  APPLY: { label: 'CA办理', value: 1 },
  CHANGE: { label: 'CA变更', value: 2 }
})

// CA办理流程状态
export const processStatusDict = new DictUtil({
  PENDING: { label: '待处理', value: 0 },
  FINISH: { label: '已处理', value: 1 }
})

// 在线签章审核开通状态
export const sealAuditStatusDict = new DictUtil({
  TO_AUDIT: {
    value: 1,
    label: '待审核',
    auditLabel: '待审核',
    type: 'info'
  },
  PASS: {
    value: 2,
    label: '通过',
    auditLabel: '通过',
    type: 'success'
  },
  REFUSE: {
    value: 3,
    label: '驳回',
    auditLabel: '驳回',
    type: 'danger'
  }
})
